// utils/parseDuration.js

/**
 * แปลง duration ที่ผู้ใช้กรอกเป็น 'นาที' (number)
 * รองรับทั้ง string: "1h 30min", "45min", "2 hr", "1 ชั่วโมง", "08:00-09:30", "1.5h", "90"
 * @param {string} str 
 * @returns {number} จำนวน "นาที" ทั้งหมด
 */
export default function parseDuration(str) {
    if (str == null || str === "") return 0;
    if (typeof str === "number") return Math.round(str);
    str = String(str).trim().replace(/\s+/g, " ");
  
    // เคส 1: ช่วงเวลา เช่น "08:00-09:30" (support space รอบขีด)
    if (/^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/.test(str)) {
      const [start, end] = str.split("-").map(s => s.trim());
      const [sh, sm] = start.split(":").map(Number);
      const [eh, em] = end.split(":").map(Number);
      let diff = (eh * 60 + em) - (sh * 60 + sm);
      if (diff < 0) diff += 24 * 60; // ข้ามวัน
      return diff;
    }
  
    let min = 0;
    let match;
    // ชั่วโมง (รองรับทศนิยม + จุด)
    match = str.match(/(\d+(?:\.\d+)?)\s*(ชั่วโมง|h\.?|hr\.?|hrs\.?)/i);
    if (match) min += Number(match[1]) * 60;
    // นาที (รองรับทศนิยม)
    match = str.match(/(\d+(?:\.\d+)?)\s*(นาที|m\.?|min\.?|mins\.?)/i);
    if (match) min += Number(match[1]);
    // ตัวเลขล้วน
    match = str.match(/^(\d+(?:\.\d+)?)\s*$/);
    if (match) min += Number(match[1]);
    // เผื่อ parse ได้
    if (!min && !isNaN(Number(str))) return Number(str);
  
    return Math.round(min);
  }